import { CaseNotes } from "./case-notes.model";

export class CaseNotesSummary{
  constructor(
    
    public person_id?: number,
    public caseNotes?: CaseNotes[],
    
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/case-notes-summary.model.ts